import React  from "react";
import { useParams } from 'react-router-dom';
import OvertimeForm from "./components/OvertimeForm";
import Card from "components/card";


const EditOvertime = () => {

	const { overtimeId } = useParams();

	return (
	   <div>
			<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<OvertimeForm recordId={overtimeId} mode="edit"/>
				</div>
			</Card>
	    </div>
    );
};

export default EditOvertime;